import { createRoot } from "react-dom/client";

/**
 * The entry point of `insurer-web`, `P0-UIK-020`.
 *
 * **What this file does, and what it deliberately does not.** It finds the
 * mount point and opens a React root on it. That is the whole of it, and the
 * restraint is the point rather than an omission.
 *
 * This item's scope is *"a bundler, an entry point and a `build` script per
 * app"* , the machinery that turns a component tree into something a static
 * host can serve. It is NOT the wiring of l'assureur's screens. `this application's shell, when it is built`
 * takes required props, and inventing values for them here would be writing
 * product inside an infrastructure item: a router, a session gate and a role
 * whitelist would all have to be guessed, and each is owned by a screen item
 * that names its own workflow ids.
 *
 * So the shells stay where they are, compiled by `typecheck` and exercised by
 * their own specs, and this entry mounts an empty root. When the screens'
 * items land they replace this body , not this file's existence.
 */
const racine = document.querySelector("#racine");
if (racine === null) {
  // Not a silent no-op: a missing mount point means the entry document and the
  // entry script disagree, and the page would be blank with nothing in the
  // console to say why.
  throw new Error("racine introuvable");
}

createRoot(racine).render(null);
